import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import { MerchantUserDto, MerchantUsersService, SystemActionParamDto } from './merchant-users.service';

@Component({
  selector: 'app-merchant-users-form',
  templateUrl: './merchant-users-form.component.html',
  styleUrls: ['./merchant-users-form.component.sass'],
})
export class MerchantUsersFormComponent implements OnInit {
  form!: FormGroup;
  isEdit = false;
  userId: string | null = null;
  loading = false;
  saving = false;

  myPermissions: SystemActionParamDto[] = [];
  selectedPermissionIds: string[] = [];

  genderOptions = ['Masculino', 'Feminino', 'Outro', 'Prefiro não informar'];

  constructor(
    private fb: FormBuilder,
    private svc: MerchantUsersService,
    private route: ActivatedRoute,
    private router: Router,
    private toast: ToastService,
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      document: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      phone: ['', Validators.required],
      gender: [''],
    });

    this.userId = this.route.snapshot.paramMap.get('id');
    this.isEdit = !!this.userId;

    this.loadPermissions();

    if (this.isEdit) {
      this.loading = true;
      this.svc.list().subscribe({
        next: (list) => {
          const user = list.find(u => u.id === this.userId);
          if (user) {
            this.form.patchValue(user);
            this.selectedPermissionIds = user.permissionIds ?? [];
          }
          this.loading = false;
        },
        error: () => { this.toast.showError('Erro ao carregar usuário.'); this.loading = false; },
      });
    }
  }

  loadPermissions(): void {
    this.svc.getMyPermissions().subscribe({
      next: (perms) => this.myPermissions = perms,
      error: () => {},
    });
  }

  togglePermission(id: string): void {
    const idx = this.selectedPermissionIds.indexOf(id);
    if (idx >= 0) {
      this.selectedPermissionIds.splice(idx, 1);
    } else {
      this.selectedPermissionIds.push(id);
    }
  }

  isSelected(id: string): boolean {
    return this.selectedPermissionIds.includes(id);
  }

  save(): void {
    if (this.form.invalid) { this.form.markAllAsTouched(); return; }
    const dto: MerchantUserDto = { ...this.form.value, permissionIds: this.selectedPermissionIds };
    this.saving = true;

    const obs = this.isEdit
      ? this.svc.update(this.userId!, dto)
      : this.svc.create(dto);

    obs.subscribe({
      next: () => {
        this.toast.showSuccess(this.isEdit ? 'Usuário atualizado.' : 'Usuário criado.');
        this.saving = false;
        this.goBack();
      },
      error: (err) => {
        this.toast.showError(err?.error?.message ?? 'Erro ao salvar usuário.');
        this.saving = false;
      },
    });
  }

  goBack(): void {
    this.router.navigate(['merchants', 'users']);
  }
}
